import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const AmbassadorMedalEmpty = withDefaultIconProps(
  {
    height: 144,
    width: 106,
  },
  ({ color: _color, ...rest }) => (
    <Svg {...rest} viewBox="-10 -2 127 145">
      <Path
        d="M23.251 103.865v31.123c0 3.604 4.164 5.59 6.94 3.309l20.12-16.535a4.232 4.232 0 015.38 0l20.12 16.535c2.776 2.281 6.94.295 6.94-3.309v-31.123"
        fill="none"
        stroke="#999"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8 8"
      />
      <Path
        d="M104 53.282c0 28.322-22.834 51.282-51 51.282S2 81.604 2 53.282C2 24.96 24.834 2 53 2s51 22.96 51 51.282z"
        fill="none"
        stroke="#999"
        strokeWidth={4}
        strokeLinecap="round"
        strokeDasharray="8 8"
      />
      <Path
        d="M37.278 40.778a25.417 25.417 0 00-1.29 8.06c0 11.872 7.94 21.495 17.734 21.495m0 0c9.795 0 17.733-9.623 17.733-21.496a25.42 25.42 0 00-1.288-8.06M53.722 70.334c5.373 0 7.389 8.867 7.389 8.867m-7.389-8.867c-5.373 0-7.389 8.867-7.389 8.867m26.66-46.61c.862 4.925-3.016 8.188-3.016 8.188s-4.737-1.664-5.6-6.591C63.514 29.263 67.39 26 67.39 26s4.738 1.664 5.601 6.59z"
        fill="none"
        stroke="#999"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="9.38 9.38"
      />
      <Path
        d="M35.3 70.894c4.433-1.702 5.122-6.472 5.122-6.472s-3.745-3.07-8.178-1.369c-4.433 1.703-5.122 6.473-5.122 6.473s3.745 3.068 8.178 1.365m45.3-17.878c-3.787 3.742-8.914 2.247-8.914 2.247s-1.342-5.237 2.447-8.985c3.783-3.742 8.914-2.246 8.914-2.246s1.341 5.237-2.447 8.984zm-8.453 17.881c-4.434-1.702-5.125-6.472-5.125-6.472s3.744-3.068 8.178-1.369c4.433 1.703 5.122 6.473 5.122 6.473s-3.742 3.068-8.175 1.368zm-45.303-17.88c3.783 3.741 8.914 2.246 8.914 2.246s1.342-5.237-2.447-8.985c-3.786-3.739-8.914-2.246-8.914-2.246s-1.342 5.237 2.447 8.984zm7.608-20.423c-.863 4.924 3.015 8.187 3.015 8.187s4.737-1.664 5.6-6.591C43.93 29.263 40.053 26 40.053 26s-4.738 1.664-5.601 6.59z"
        fill="none"
        stroke="#999"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="9.38 9.38"
      />
    </Svg>
  ),
);
